import bmeDark from '@/assets/img/supporters/bme_dark.svg'
import bmeLight from '@/assets/img/supporters/bme_light.svg'
import schdesignDark from '@/assets/img/supporters/schdesign_dark.svg'
import schdesignLight from '@/assets/img/supporters/schdesign_light.svg'
import schonherzDark from '@/assets/img/supporters/schonherz_dark.svg'
import schonherzLight from '@/assets/img/supporters/schonherz_light.svg'
import vikDark from '@/assets/img/supporters/vik_dark.svg'
import vikLight from '@/assets/img/supporters/vik_light.svg'
import { useColorModeValue } from '@/util/core-functions.util'

const partnerLogos = {
  bme: { light: bmeLight, dark: bmeDark },
  schonherz: { light: schonherzLight, dark: schonherzDark },
  schdesign: { light: schdesignLight, dark: schdesignDark },
  vik: { light: vikLight, dark: vikDark }
} as const

export type PartnerLogoName = keyof typeof partnerLogos

export function PartnerLogo({ name }: { name: PartnerLogoName }) {
  const fileVariant = useColorModeValue('light', 'dark')
  const alt = {
    bme: 'BME',
    schonherz: 'Schönherz',
    schdesign: 'schdesign',
    vik: 'BME VIK'
  }[name]

  return (
    <div className="m-5 flex h-20 w-32 shrink-0 items-center justify-center">
      <img className="max-h-full max-w-full object-contain" src={partnerLogos[name][fileVariant]} alt={alt} loading="lazy" />
    </div>
  )
}
